import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  DataPointDataType,
  DynamicComponentBase,
  IDynamicComponentConfig,
  RenderComponentBase,
  ValidationRuleType
} from '../../../dynamic-component';

@Component({
  selector: 'app-r-con-number-integer',
  templateUrl: './r-con-number-integer.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RConNumberIntegerComponent),
      multi: true
    }
  ]
})
export class RConNumberIntegerComponent extends RenderComponentBase {
  static KEY = 'r-d-con-number-integer';
  ruleType = ValidationRuleType;

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.step !== 'number') {
      config.step = 1;
    }
    if (!config.effective) {
      config.effective = [];
    }
  }
}
